import { MapInformationService } from 'src/app/services/map-information.service';
// import { NavbarSidebarComponent } from 'src/app/shared/navbar-sidebar/navbar-sidebar.component';

import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DxDropDownBoxComponent,DxDropDownBoxModule, DxCheckBoxModule,  DxSelectBoxComponent, DxTreeViewComponent, DxTreeViewModule } from 'devextreme-angular';
import { EstimateService } from 'src/app/services/estimate.service';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { isArray } from 'util';


@Component({
  selector: 'app-applications',
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss']
})

export class ApplicationsComponent implements OnInit {

 showFiltersModal: boolean = false
  showFiltersAIModal: boolean = false
  filterNew: FormGroup
  manufactureDatasource: any;

  @ViewChild("treeViewType", { static: false }) treeViewType: DxTreeViewComponent;


  showFilters() {
    this.componentModel = {
      COMPSCOPE: "",
      COMPSCOPEWITHOUTHTML: "",
      ID: 0,
      NAME: "",
      SystemType: "",
      TypeId: [],
      Image: 'Not_Image',
      VisionComponentName: '',
      Path: '',
      filename: '',
      ACHR: '',
      tagid: [],
      tagParent: 0,
      typeImage: "",
      notshowiddwg: false,
      applicationtypeid: [],
      notschematic: false,
      manufactureID: 0,
      catalogNumber: ""
    };
    this.showFiltersModal = true
    this.getTagParents()
    this.getManufacture(null)
  }

  tagsParens: any[] = []
  taggingDatasource: any[] = []
  componentModel = {
    COMPSCOPE: "",
    COMPSCOPEWITHOUTHTML: "",
    ID: 0,
    NAME: "",
    SystemType: "",
    TypeId: [],
    Image: 'Not_Image',
    VisionComponentName: '',
    Path: '',
    filename: '',
    ACHR: '',
    tagid: [],
    tagParent: 0,
    typeImage: "",
    notshowiddwg: false,
    applicationtypeid: [],
    notschematic: false,
    manufactureID: 0,
    catalogNumber: ""
  };

  systemTypeSelectCE: any[] = []

  getTagParents() {
    this.MapInformationService.SaveInfoSites({ method: "Get_EcomEstimateSytemTypeCEWithoutFirstParent" })
      .subscribe(resp => {
        this.systemTypeSelectCE = resp
      })

    // this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
    //   this.systemTypeSelectCE = result;
    // });
  }

  changeSegmentParents(e) {
    this.getTagging(e.selectedItem.ID)
  }

  // getTagging(id) {
  //   this.MapInformationService.SaveInfoSites({ 'method': 'Get_TagEngUtilityByParentID', parentid:id}).subscribe(result => {
  //     this.taggingDatasource = result;
  //   });
  // }


  getTagging(id: any) {
    this.MapInformationService.SaveInfoSites({ 'method': 'Get_EcomComponentsTreeFilter', id: id }).subscribe(result => {
      this.taggingDatasource = result;
    });
  }

  getManufacture(id: any) {
    this.MapInformationService.SaveInfoSites({ 'method': 'GetShopManufacturers' }).subscribe(result => {
      this.manufactureDatasource = result;
      console.log(this.manufactureDatasource)
      });
  }



  dataMenuNavbar: any

  searchData() {

    const idsTags = this.componentModel.tagid.join(",")
    const idMastertype = this.componentModel.tagParent


    this.showFiltersModal = false
    this.clearFilterIndividual('Clear')

    this.router.navigate(['/Applicationfiltered'], { queryParams: { idMaster: idMastertype, componentids: idsTags, 
      manufactureID: this.componentModel.manufactureID, catalogNumber: this.componentModel.catalogNumber } });
    if (this.dataMenuNavbar == "Applicationfiltered") {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }


  }

  searchDataAI() {

    const idMastertype = this.componentModel.tagParent


    this.showFiltersAIModal = false;
    this.clearFilterIndividual('Clear')

    this.router.navigate(['/AIShop'], { queryParams: { idType: idMastertype } });

  }
  @ViewChild('treeviewType', { static: false }) treeviewType: DxTreeViewComponent;
    @ViewChild('treeviewTag', { static: false }) treeviewTag: DxTreeViewComponent;
  
  
    @ViewChild('treeBoxType', { static: false }) treeBoxType: DxDropDownBoxComponent;
    @ViewChild('treeBoxTags', { static: false }) treeBoxTags: DxDropDownBoxComponent;

  closeParentsSystemType() {
    this.treeviewTag.instance.collapseAll()
  }

  OpenParentsSystemType() {
    this.treeviewTag.instance.expandAll()
  }


  closeParentsComponentType() {
    this.treeviewType.instance.collapseAll()
  }

  OpenParentsComponentType() {
    this.treeviewType.instance.expandAll()
  }

  groupItemsFilter: any[] = []
  typeDatasource: any[] = []
  openFilterParents() {

    this.estimateService.Get_EstimateLibComponentsTreeCE2().subscribe(result => {
      this.groupItemsFilter = result
    });

    this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
      this.typeDatasource = result;
    });
  }

  typeids: any[] = []
  treeBoxValue2: string[] = [];
  notAllowed: boolean = false
  FirtsTime: boolean = true




  clearFilterIndividual(typeOfClear) {
    switch (typeOfClear) {
      case 'System Type':
        this.typeids = []
        this.treeBoxValue2 = []
        if (this.treeBoxTags != undefined) {
          this.treeBoxTags.instance.reset()
        }

        if (this.treeviewTag != undefined) {
          this.treeviewTag.instance.unselectAll()
        }

        this.filterNew.get("systemtypeID").setValue("")

        break
      case 'Component Type':
        this.categorySelected = []
        this.treeBoxValue = []
        if (this.treeBoxType != undefined) {
          this.treeBoxType.instance.reset()
        }
        if (this.treeviewType != undefined) {
          this.treeviewType.instance.unselectAll()
        }
        this.filterNew.get("componentType").setValue("")
        break
      default:
        this.clearDataAll()
        break
    }
  }

  clearDataAll() {
    this.typeids = []
    this.treeBoxValue2 = []
    this.showFiltersAIModal = false
    if (this.treeBoxTags != undefined) {
      this.treeBoxTags.instance.reset()
    }

    if (this.treeviewTag != undefined) {
      this.treeviewTag.instance.unselectAll()
    }

    if (this.filterNew != undefined) {
      this.filterNew.get("systemtypeID").setValue("")
    }
    // *******************************************************
    this.categorySelected = []
    this.treeBoxValue = []
    if (this.treeBoxType != undefined) {
      this.treeBoxType.instance.reset()
    }
    if (this.treeviewType != undefined) {
      this.treeviewType.instance.unselectAll()
    }
    if (this.filterNew != undefined) {
      this.filterNew.get("componentType").setValue("")
    }
  }

  clearInputFields() {
    // Limpiar los valores de los inputs del componentModel
    this.componentModel.tagParent = 0;
    this.componentModel.tagid = [];
    this.componentModel.manufactureID = 0;
    this.componentModel.catalogNumber = "";

  }

  onTagSelectionChanged(event) {
    
    if (event.event != undefined) { 
      console.log('Tag selection changed:', event);
      this.componentModel.manufactureID = 0;
      this.componentModel.catalogNumber = "";
      
      this.componentModel.tagid = event.value || [];

      this.getContadorSystems()
    }
  }

  onManufacturerSelectionChanged(event) {
    console.log('Manufacturer selection changed:', event);

    if (event.event != undefined) {
      this.componentModel.catalogNumber = "";
  
      this.componentModel.tagid = []; 
  
      this.componentModel.tagParent = 0;

      this.getContadorSystems()
    }
    
    
  }

  onCatalogNumberChanged(event) {
    console.log('Catalog Number changed:', event);

    if (event.event != undefined) {
      this.componentModel.tagid = [];
      
      this.componentModel.tagParent = 0;
      
      this.componentModel.manufactureID = 0;

      this.getContadorSystems()
    }
  }






  @ViewChild(DxTreeViewComponent, { static: false }) treeView;

  categorySelected: any[] = []
  treeBoxValue: string[];

  syncTreeViewSelection(e) {
    var component =
      (e && e.component) || (this.treeView && this.treeView.instance);

    if (!component) return;

    if (!this.treeBoxValue) {
      component.unselectAll();
    }

    if (this.treeBoxValue) {
      this.treeBoxValue.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }
  }

  treeView_itemSelectionChanged(e) {
    // Si es la primera vez que se selecciona algo, realizar la misma operación
    if (e.itemElement !== undefined) {

      this.componentModel.tagParent = e.component.getSelectedNodeKeys();
      this.treeBoxValue = e.component.getSelectedNodeKeys();
      this.FirtsTime = false;
      this.getTagging(e.itemData.ID)

      this.componentModel.manufactureID = 0;
      this.componentModel.catalogNumber = "";
      this.componentModel.tagid = []

      this.getContadorSystems()

    }
  }

  systemcount: number = 0

  getContadorSystems(){
    // Get_EcomMainCategoriesApSysCount

    let dataParent: string | number = this.componentModel.tagParent

    if (isArray(this.componentModel.tagParent)){
      dataParent = this.componentModel.tagParent.join(",")
    } else if (typeof this.componentModel.tagParent === 'string' && (this.componentModel.tagParent as string).includes(',')) {
      dataParent = (this.componentModel.tagParent as string).split(',').map(id => Number(id)).filter(id => !isNaN(id)).join(",")
    }

    let data = {
      "method": "Get_EcomMainCategoriesApSysCount",
      "compids": this.componentModel.tagid.join(","),
      "parentid": dataParent != undefined ? dataParent : "",
      "manufacturerid": this.componentModel.manufactureID != undefined ? this.componentModel.manufactureID : 0,
      "systemid": this.componentModel.catalogNumber != "" ? this.componentModel.catalogNumber : 0
    }

    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp=>{
      console.log(resp)
      this.systemcount = resp[0].systemcount
    })
  }


  @ViewChild(DxTreeViewComponent, { static: false }) treeView2;

  syncTreeViewSelection2(e) {
    var component = (e && e.component) || (this.treeView2 && this.treeView2.instance);

    if (!component) return;

    // Desmarcar todos los elementos si no hay valores seleccionados
    if (!this.treeBoxValue2 || this.treeBoxValue2.length === 0) {
      component.unselectAll();
    } else {
      // Asegurarse de que solo se seleccionen los elementos presentes en treeBoxValue2
      component.unselectAll(); // Limpiar selección previa

      this.treeBoxValue2.forEach(function (value) {
        component.selectItem(value); // Seleccionar cada valor
      });
    }
  }

  treeView_itemSelectionChanged2(e) {

    // Si es la primera vez que se selecciona algo, realizar la misma operación
    if (e.itemElement !== undefined) {
      this.componentModel.tagid = e.component.getSelectedNodeKeys();
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();
      this.FirtsTime = false;
    }
  }

  
  menuItems = [
    // {
    //      text: 'HOME'
    //  },
    //   {
    //      text: 'PRODUCTS',

    //  }, 
     {
         text: 'APPLICATIONS'
     }];

     galleryDataSource = [
        { path: "assets/mac.jpg" },
        { path: "assets/person-music1100x700.jpg" }

   ];

   tileViewData = [
      { name: "Product Name 1" },
      { name: "Product Name 2"},
      { name: "Product Name 3" },
      { name: "Product Name 4"}

      // ...
  ];

  dataSource:any[]=[]

  openFullScreen:boolean = true
  SystemIDSelected:any
  estimateIDSelected:any
  estimatenamestrSelected:any
  projectIDSelected:any

  screen(width) {
       return ( width < 700 ) ? 'sm' : 'lg';
   }
  constructor(
    private MapInformationService:MapInformationService,
    private router: Router, 
    private estimateService: EstimateService,
    private deltaService: DeltaworldService,
    // public NavbarSidebarComponent:NavbarSidebarComponent
    
    ) { 

      // this.NavbarSidebarComponent.ApplicationsComponentFunctions = this
    }

  ngOnInit() {
    this.getTagParents();
    this.getApplications()

    this.estimateIDSelected = localStorage.getItem("estimateIDSelected")
    this.estimatenamestrSelected = localStorage.getItem("estimatenamestrSelected")
    this.projectIDSelected = localStorage.getItem("projectIDSelected")
    this.getManufacture(null)
  }


  getApplications(){
    console.log("aqui")
    this.MapInformationService.SaveInfoSites({method:"Get_EcomMainCategoriesAp_CR"})
    .subscribe(resp=>{
      console.log(resp)
      let dataTemporal = []
      let contador = 0
      resp.forEach(element => {
        if (element.CATIMAGE != "MCNoImage.JPG" && element.CATIMAGE != undefined){
          this.MapInformationService.DowloadDocumentlowQuality(element.CATIMAGE).subscribe(result => {
  
            let tipo = ""
            let data = ""
            
            if (result.filestring != undefined){
              data = result.filestring.substring(0, 5);
            } else {
              data = ""
            }
            
            console.log(data.toUpperCase())
      
            switch(data.toUpperCase()){
              case "IVBOR":tipo = "png";
              break
              case "/9J/4":tipo = "jpg";
              break
              case "JVBER":tipo = "pdf";
              break
              case "UESDB":
                var data2 = result.filestring.substring(0, 19);
                switch(data.toUpperCase()){
                  case "UEsDBBQABgAIAAAAIQB":tipo = "xlsx";
                  break
                  default:
                    var data3 = result.filestring.substring(0, 18);
                    switch(data.toUpperCase()){
                      case "UEsDBBQABgAIAAAAIQ":tipo = "docx";
                      break
                      default:tipo = "zip";
                    }
                }
              break
              case "UMFYI":tipo = "rar";
              break
              case "U1PKC":tipo = "txt";
              break
            }

            element.base64 = result.filestring == "" ? "Not_image" : result.filestring
            element.tipo = result.filestring == "" ? "png" : tipo
            // element.base64 = "Not_image"
            // element.tipo = "png"
            dataTemporal.push(element)
            contador++
            if (contador == resp.length) {
              this.dataSource = dataTemporal.sort((a, b) => {
                const valueA = a.SystemType.toLowerCase();
                const valueB = b.SystemType.toLowerCase();
            
                if (valueA < valueB) {
                  return -1;
                } else if (valueA > valueB) {
                  return 1;
                } else {
                  return 0;
                }
              });
              console.log(this.dataSource)
            }

          });
        } else {
          contador++
          element.base64 = "Not_image"
          element.tipo = "png"
          dataTemporal.push(element)
          if (contador == resp.length) {
            this.dataSource = dataTemporal.sort((a, b) => {
              const valueA = a.SystemType.toLowerCase();
              const valueB = b.SystemType.toLowerCase();
          
              if (valueA < valueB) {
                return -1;
              } else if (valueA > valueB) {
                return 1;
              } else {
                return 0;
              }
            });
            console.log(this.dataSource)
          }
        }
      })
    })
  }

  itemClick(e) {
    if (e.itemData.text == 'HOME'){
      this.router.navigateByUrl('/productsCart');
    }
    if (e.itemData.text == 'PRODUCTS'){
      // this.router.navigateByUrl('/productsCategory');
      this.router.navigateByUrl('/products');
    }
    if (e.itemData.text == 'APPLICATIONS'){
      this.router.navigateByUrl('/applications');
    }
    console.log(e);
  }

  goToProduct(info){
    console.log(info)
    this.router.navigate(['/ApplicationType'], { queryParams: { id: info.ID } });
  }

  SelectCategory(item){
    console.log(item)
    if(item.NumberOfChild > 0){
      this.router.navigate(['/ApplicationType'], { queryParams: { parentID: item.ID, nameApplication: item.SystemType } });
    } else {
      if(item.NumberOfSystems > 0){
        this.router.navigate(['/ListSystems'], { queryParams: { id: item.ID, nameChild: item.SystemType, parentID: item.ID, nameParent: item.SystemType} });
      } else {
        console.log('error')
      }
    }
  }

  goBackEstimate(){
    console.log("back")

    this.router.navigate(['/Estimates/editEstimate'], { queryParams: { numESTIMATEID: this.estimateIDSelected, numProjectID:this.projectIDSelected, strPROJECT_NAME:this.estimatenamestrSelected} });
  }

}
